import axios from 'axios'

export default class politicas {
    public async getPoliticas(): Promise<string | undefined> {
        const response = await axios.get('./politicas/politicas.json')
        // Retorno de datos
        return response.data;
    }
}